import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Chip } from 'primereact/chip';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useGetProjectsBySkill } from '../../services/api/projects-api';
import { SkillProjectsPopupStyles } from './skill-projects-popup.styles';

export default function SkillProjectsPopup({ visible, onHide, skill }) {
  const { data: projects, isLoading } = useGetProjectsBySkill(skill?.id, {
    enabled: !!skill?.id && visible,
  });

  return (
    <Dialog
      header={`Projects using ${skill?.name || 'this skill'}`}
      visible={visible}
      onHide={onHide}
      style={{ width: '50vw' }}
      breakpoints={{ '960px': '75vw', '641px': '95vw' }}
    >
      <SkillProjectsPopupStyles>
        {isLoading ? (
          <div className="loading-container">
            <ProgressSpinner />
          </div>
        ) : projects && projects.length > 0 ? (
          <div className="projects-grid">
            {projects.map((project) => (
              <div key={project.id} className="project-card">
                {project.cover_image_url && (
                  <div className="project-image">
                    <img src={project.cover_image_url} alt={project.title} />
                  </div>
                )}
                <div className="project-content">
                  <h3>{project.title}</h3>
                  {project.description && (
                    <p className="description">{project.description}</p>
                  )}
                  {project.status && (
                    <Chip
                      label={project.status}
                      className={`status-chip status-${project.status.toLowerCase()}`}
                    />
                  )}
                  {project.links && project.links.length > 0 && (
                    <div className="links">
                      {project.links.map((link, index) => (
                        <a
                          key={index}
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="project-link"
                        >
                          {link.label || link.url}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <p>No projects found using this skill yet.</p>
          </div>
        )}
      </SkillProjectsPopupStyles>
    </Dialog>
  );
}
